import { isValidElement, ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import { styled as styledMui5 } from '@mui/material/styles';

type Props = {
  title: string;
  preSubtitle?: string;
  subtitle?: string;
  children?: ReactNode;
  Icon?: ReactNode;
};

const Title = styledMui5(Typography)(
  ({ theme }) => `
  &.MuiTypography-root {
    margin: ${theme.spacing(2, 0)};
    font-size: 2.125rem;
    display: block;
  }`,
);
const Subtitle = styledMui5(Typography)(
  ({ theme }) => `
  &.MuiTypography-root {
    margin: ${theme.spacing(2, 'auto')};
    font-size: 1rem;
    display: block;
    ${theme.breakpoints.up('sm')} {
      max-width: 55%;
    }
  }`,
);

const Wrapper = styledMui5('div')(
  ({ theme }) => `
  padding: ${theme.spacing(10, 4)};
  text-align: center;
  width: 100%;
  align-self: center;
`,
);

export default function EmptyState({
  title,
  preSubtitle,
  subtitle,
  children,
  Icon,
}: Props): JSX.Element {
  return (
    <Wrapper>
      {isValidElement(Icon) && Icon}
      <Title variant='caption' color='primary'>
        {title}
      </Title>
      {preSubtitle && <Subtitle variant='caption'>{preSubtitle}</Subtitle>}
      {subtitle && (
        <Subtitle variant='caption' color='textSecondary'>
          {subtitle}
        </Subtitle>
      )}
      {children}
    </Wrapper>
  );
}
